import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { companyInfo } from '@/mocks/companyData';

export default function Terms() {
  const lastModified = '2025年4月1日';

  return (
    <div className="min-h-screen">
      <Navbar />

      {/* Hero */}
      <section className="pt-32 pb-16 md:pt-40 md:pb-20 bg-background-100">
        <div className="max-w-[1280px] mx-auto px-6 md:px-10">
          <div className="max-w-3xl">
            <span className="inline-block text-xs font-medium tracking-[0.15em] text-primary-600 bg-primary-100/70 px-4 py-1.5 rounded-full mb-6">
              TERMS OF USE
            </span>
            <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight mb-6 tracking-wide">
              利用規約
            </h1>
            <p className="text-sm text-foreground-500">
              最終更新日：{lastModified}
            </p>
          </div>
        </div>
      </section>

      {/* Terms Grid */}
      <section className="py-12 bg-background-100">
        <div className="max-w-[1280px] mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-background-50 rounded-2xl p-8 group hover:bg-primary-50 transition-all duration-500 cursor-default">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100/70 text-primary-600 mb-5 font-heading font-bold">
                01
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-3 tracking-wide">適用範囲</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                本規約は、当社サービスの利用に関する一切の関係に適用されます。
              </p>
            </div>
            <div className="bg-background-50 rounded-2xl p-8 group hover:bg-primary-50 transition-all duration-500 cursor-default">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100/70 text-primary-600 mb-5 font-heading font-bold">
                02
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-3 tracking-wide">利用登録</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                正確な情報を提供し、登録申請を行うものとします。
              </p>
            </div>
            <div className="bg-background-50 rounded-2xl p-8 group hover:bg-primary-50 transition-all duration-500 cursor-default">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100/70 text-primary-600 mb-5 font-heading font-bold">
                03
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-3 tracking-wide">禁止事項</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                法令違反、公序良俗に反する行為、サービスの妨害等を禁止します。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Full Terms Text */}
      <section className="py-16 md:py-20">
        <div className="max-w-[1280px] mx-auto px-6 md:px-10">
          <div className="max-w-3xl">
            <article className="prose prose-sm max-w-none text-foreground-700 leading-relaxed space-y-8">

              <div>
                <h2 className="font-heading text-lg font-bold text-foreground-900 mb-4 tracking-wide">第1条（適用）</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  本規約は、{companyInfo.name}（以下「当社」といいます。）が提供するすべてのサービス（以下「本サービス」といいます。）の利用に関する、当社とお客様との間の権利義務関係を定めることを目的とし、お客様と当社の間の本サービスの利用に関わる一切の関係に適用されます。
                </p>
              </div>

              <div>
                <h2 className="font-heading text-lg font-bold text-foreground-900 mb-4 tracking-wide">第2条（利用登録）</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  本サービスの利用を希望する者は、当社の定める方法により利用登録を申請し、当社がこれを承諾することによって、利用登録が完了するものとします。当社は、利用登録の申請者に以下の事由があると判断した場合、利用登録の申請を承諾しないことがあります。
                </p>
                <ul className="list-disc pl-6 space-y-2 mt-3">
                  <li className="text-sm text-foreground-600 leading-relaxed">虚偽の事項を届け出た場合</li>
                  <li className="text-sm text-foreground-600 leading-relaxed">過去に本規約に違反した者である場合</li>
                  <li className="text-sm text-foreground-600 leading-relaxed">その他、当社が利用登録を相当でないと判断した場合</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-lg font-bold text-foreground-900 mb-4 tracking-wide">第3条（ユーザーIDおよびパスワードの管理）</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  お客様は、自己の責任において、本サービスのユーザーIDおよびパスワードを適切に管理するものとします。お客様は、いかなる場合にも、ユーザーIDおよびパスワードを第三者に譲渡または貸与し、もしくは第三者と共用することはできません。
                </p>
              </div>

              <div>
                <h2 className="font-heading text-lg font-bold text-foreground-900 mb-4 tracking-wide">第4条（禁止事項）</h2>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  お客様は、本サービスの利用にあたり、以下の行為をしてはなりません。
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li className="text-sm text-foreground-600 leading-relaxed">法令または公序良俗に違反する行為</li>
                  <li className="text-sm text-foreground-600 leading-relaxed">犯罪行為に関連する行為</li>
                  <li className="text-sm text-foreground-600 leading-relaxed">当社のサーバーやネットワークの機能を妨害する行為</li>
                  <li className="text-sm text-foreground-600 leading-relaxed">当社のサービス運営を妨害するおそれのある行為</li>
                  <li className="text-sm text-foreground-600 leading-relaxed">他のお客様の個人情報を収集または蓄積する行為</li>
                  <li className="text-sm text-foreground-600 leading-relaxed">不正アクセスを試みる行為</li>
                  <li className="text-sm text-foreground-600 leading-relaxed">当社のサービスに関連して反社会的勢力に利益を供与する行為</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-lg font-bold text-foreground-900 mb-4 tracking-wide">第5条（本サービスの提供の停止等）</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  当社は、以下のいずれかの事由があると判断した場合、お客様に事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。本サービスにかかるコンピュータシステムの保守点検または更新を行う場合、地震・落雷・火災等の不可抗力により本サービスの提供が困難となった場合、その他当社が停止または中断を必要と判断した場合。
                </p>
              </div>

              <div>
                <h2 className="font-heading text-lg font-bold text-foreground-900 mb-4 tracking-wide">第6条（免責事項）</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  当社は、本サービスに事実上または法律上の瑕疵（安全性、信頼性、正確性、完全性、有効性、特定の目的への適合性、セキュリティなどに関する欠陥、エラーやバグ、権利侵害などを含みます。）がないことを明示的にも黙示的にも保証しておりません。当社は、お客様に対して、かかる瑕疵を除去して本サービスを提供する義務を負いません。
                </p>
              </div>

              <div>
                <h2 className="font-heading text-lg font-bold text-foreground-900 mb-4 tracking-wide">第7条（サービス内容の変更等）</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  当社は、お客様に通知することなく、本サービスの内容を変更し、または本サービスの提供を中止することができるものとし、これによってお客様に生じた損害について一切の責任を負いません。
                </p>
              </div>

              <div>
                <h2 className="font-heading text-lg font-bold text-foreground-900 mb-4 tracking-wide">第8条（利用規約の変更）</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  当社は、必要と判断した場合には、お客様に通知することなく本規約を変更することができるものとします。変更後の利用規約は、本ウェブサイトに掲載した時点から効力を生じるものとします。
                </p>
              </div>

              <div>
                <h2 className="font-heading text-lg font-bold text-foreground-900 mb-4 tracking-wide">第9条（準拠法・管轄裁判所）</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  本規約の解釈にあたっては、日本法を準拠法とします。本サービスに関して紛争が生じた場合には、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
                </p>
              </div>

            </article>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}